(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('ListTemplateViewCtrlService', ListTemplateViewCtrlService);

    function ListTemplateViewCtrlService(lodash, GenericModel, $templateCache) {
        return function (options) {
            let state = {};
            init();
            return ExposedMethods;

            function ExposedMethods() {
                return {
                    refreshDatasource: refreshDatasource,
                    toggleSelected: toggleSelected,
                    action: action,
                    getState: getState,
                    setState: setState,
                    syncState: syncState,
                    syncModel: syncModel,
                    clearSelection: clearSelection,
                    hasNoSelection: hasNoSelection,
                };
            }

            /**
             * Initialise the Controller
             */
            function init() {
                let template = '<div>No Templates Loaded</div>';
                if (lodash.has(options, 'templateUrl')) {
                    template = $templateCache.get(options.templateUrl);
                } else {
                    if (lodash.has(options, 'templates')) {
                        template = options.templates;
                    }
                }

                var additionalOptions = {};

                if (lodash.has(options, 'noRecordTemplate')) {
                    additionalOptions.dataBound = function(e) {
                        console.log('datasource result changes');
                        if( this.dataSource.data().length == 0){
                            //custom logic

                            this.element.append(options.noRecordTemplate);
                        }
                    }
                }

                const listOptions = {
                    templates: template,
                    attrs: lodash.get(options,'attrs', {wrapper: 'list-templates-item-wrapper'}),
                    dataSource: prepareDatasource(lodash.get(options, 'datasource', {})),
                    additionalOptions: additionalOptions
                };



                lodash.set(state, 'listOptions', listOptions);
            }

            /**
             * Performs calling of api
             */
            function readGrid(readOptions) {
                const myOptions = {};
                const method = 'query';
                const datasource = state.url;

                var data = generateResourceOption(readOptions.data, myOptions, method);

                var model = new GenericModel(datasource);
                model[method](data).$promise.then(function (res) {
                    var dataSchema = lodash.get(options, 'datasource.schema.data', 'data');
                    readOptions.success(res);
                }, function (res) {
                    setState('internalData', []);
                    readOptions.error(res);
                });
            }

            function prepareDatasource(datasource) {
                if (lodash.has(datasource, 'transport.read')) {
                    if (lodash.has(datasource.transport.read, 'url')) {
                        state.url = datasource.transport.read.url;
                        datasource.transport.read = readGrid;
                        datasource.change = bindModel;
                    }
                }
                return datasource;
            }

            function bindModel() {
                // set selected
                const dataItems = this.view();
                if (lodash.has(state, 'model.selected') && !lodash.isEmpty(state.model.selected)) {
                    // lodash.isEmpty works on array, object, set map only. Doesn't work for primitive types
                    angular.forEach(state.model.selected, (_model)=> {
                        const entity = lodash.find(dataItems, {select_id: _model.select_id});
                        if (entity) {
                            entity.selected = true;
                        }
                    });
                }

                // angular.forEach(dataItems, function(dataItem) {
                //     const entity = lodash.find(state, {select_id: dataItem.select_id});
                //     if (!entity) {
                //         toggleSelected(dataItem);
                //     }
                // });
            }

            function generateResourceOption(resourceData, myData, method) {
                var params = {};
                params = angular.merge(params, resourceData, myData);
                if (method == 'search') {
                    params = {'data': params};
                }
                return params;
            }


            /**
             * Calls Kendo List Api to refresh its datasource.
             */
            function refreshDatasource() {
                if (lodash.has(state, 'listObj')) {
                    state.listObj.dataSource.read();
                }
            }

            /**
             * Set the state.
             * @param field
             * @param value
             */
            function setState(field, value) {
                lodash.set(state, field, value);
            }

            function getState() {
                if (arguments.length > 1) {
                    throw new Error('Function ListTemplateViewCtrlService.getState(), Invalid number of arguments');
                }

                if (arguments.length == 1) {
                    return state[arguments[0]];
                }

                return state;
            }

            function syncState(vm) {
                vm.stateData = state;
            }

            function syncModel(vm) {
                if (vm.model instanceof Array) {
                    vm.model = {
                        selected: []
                    };
                }
                state.model = vm.model;
            }

            function toggleSelected(dataItem) {
                if (!dataItem.selectable) return;
                if (dataItem.unselectable) return;
                if (dataItem.disabled) return;
                dataItem.selected = !dataItem.selected;

                if (dataItem.selected) {
                    if (!lodash.has(state.model, 'selected')) {
                        state.model.selected = [];
                    }
                    state.model.selected.push({
                        id: dataItem.id,
                        select_id: dataItem.select_id
                    });
                    toggleChanged();
                }

                if (!dataItem.selected) {
                    const filteredItemIndex = lodash.findIndex(state.model.selected, {select_id: dataItem.select_id});
                    if (filteredItemIndex >= 0) {
                        state.model.selected.splice(filteredItemIndex, 1);
                        toggleChanged();
                    }
                }
            }

            function action(name, dataItem) { // eslint-disable-line no-unused-vars
                // do http request, sending over name of dataItem & dataItam id;
                // run actions on http response
            }

            function clearSelection() {
                state.kendoListObj.dataSource.data().map(function(_item) {
                    _item.selected = false;
                });

                state.model.selected = [];
                toggleChanged();
            }

            function hasNoSelection() {
                return state.model.selected.length === 0;
            }

            function toggleChanged() {
                if (!!state.events.onChange && typeof state.events.onChange === typeof function() {}) {
                    state.events.onChange();
                }
            }
        };


    }
})();
